import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import camelCase from 'lodash/camelCase';

import titleClasses, {
  title,
  titleUpperCased,
  titleBebasStyle,
  titleMontserratStyle,
  titleWithBorder,
} from './scss/Title.module.scss';

const Title = ({
  value,
  size,
  fontStyle,
  uppercased,
  className,
  withBorder,
  renderAsHtml,
  ...otherProps
}) => {
  const fontSize = camelCase(`title-${size}`);
  const fontStyleClassName = {
    bebas: titleBebasStyle,
    regular: titleMontserratStyle,
  }[fontStyle];

  const computedClassNames = classNames(
    title,
    titleClasses[fontSize],
    uppercased && titleUpperCased,
    fontStyleClassName,
    className,
    withBorder && titleWithBorder
  );

  if (renderAsHtml) {
    return (
      <span
        className={computedClassNames}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  }
  return (
    <span className={computedClassNames} {...otherProps}>
      {value}
    </span>
  );
};

Title.propTypes = {
  size: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  fontStyle: PropTypes.oneOf(['regular', 'bebas']),
  value: PropTypes.node,
  withBorder: PropTypes.bool,
  uppercased: PropTypes.bool,
  renderAsHtml: PropTypes.bool,
};

Title.defaultProps = {
  size: 'md',
  uppercased: false,
  fontStyle: 'bebas',
  withBorder: false,
  renderAsHtml: false,
};

export default Title;
